<template>
    <zj-layout-container>
      <zj-layout-header style="padding:0rem 0px 0px 0px;">
        <div class="zj-button-bar" v-if="!IsEdit">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
        <el-table
          :data="tableData"
          ref="multipleTable"
          @selection-change="selectionChange"
          border
          style="width: 100%"
          height="100%"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="TaskTiltle" label="任务名称" align="center"></el-table-column>
          <el-table-column prop="ChargerName" label="负责人" align="center"></el-table-column>
          <el-table-column prop="ExecWay" label="执行方式" :formatter="ConvertExecWay" align="center"></el-table-column>
          <el-table-column prop="Phone" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="PlanResponseTime" label="响应时间" align="center"></el-table-column>
          <el-table-column prop="PlanResourceId" label="资源种类" align="center"></el-table-column>
          <el-table-column prop="OrderNo" label="执行顺序" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                @click="moveupClick(scope.$index,scope.row)"
                type="text"
                size="small"
                :disabled="scope.$index==0 || IsEdit"
              >上移</el-button>
              <el-button
                @click="movedownClick(scope.$index,scope.row)"
                type="text"
                size="small"
                :disabled="IsEdit"
              >下移</el-button>
              <el-button
                @click="placetopClick(scope.$index,scope.row)"
                type="text"
                size="small"
                :disabled="scope.$index==0 || IsEdit"
              >置顶</el-button>
              <el-button
                @click="placebottomClick(scope.$index,scope.row)"
                type="text"
                size="small"
                :disabled="IsEdit"
              >置底</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small" v-if="!IsEdit">编辑</el-button>
              <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small" v-if="!IsEdit">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
      <zj-layout-footer style="padding-bottom: 0rem;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "ZjPlanTasklist",
  controller: "UI",
  action: "PlanTasklist",
  props: {
    PlanId: String,
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      selectData: null,
      IsEdit: false
    };
  },
  created: function() {
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        PlanId: this.PlanId,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.PlanTaskApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //编辑按钮
    editClick(index, row) {
      this.$emit("editDetial", { TaskId: row.TaskId });
    },
    //查看详细
    handleClick(index, row) {
      this.$emit("handleDetial", { TaskId: row.TaskId });
    },
    onbatchDel() {
      if (this.selectData != undefined) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              this.loading = true;
              this.loadingText = '删除中...';
              new MyApis.PlanTaskApi()
                .DelItemList(selectData)
                .then(r => {
                  r = r.data.Data;
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败!"
                    });
                  }
                  this.loading = false;
                  this.search();
                })
                .catch(e => {
                  console.error(e);
                  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
                  this.loading = false;
                });
            }
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          new MyApis.PlanTaskApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.search();
            })
            .catch(e => {
              console.error(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        });
    },
    //添加
    onAdd() {
      this.$emit("addDetial", {});
    },
    //上移
    moveupClick(index, row) {
     // console.log(index);
      let searchInfo = {
        TaskId: row.TaskId,
        Operation: "up"
      };
      this.loading = true;
      this.loadingText = '更新中...';
      new MyApis.PlanTaskApi()
        .UpdateTaskOrderNo(searchInfo)
        .then(() => {
          this.loading = false;
          this.search();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //下移
    movedownClick(index, row) {
     // console.log(index);
      let searchInfo = {
        TaskId: row.TaskId,
        Operation: "down"
      };
      this.loading = true;
      this.loadingText = '更新中...';
      new MyApis.PlanTaskApi()
        .UpdateTaskOrderNo(searchInfo)
        .then(() => {
          this.loading = false;
          this.search();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //置顶
    placetopClick(index, row) {
     // console.log(index);
      let searchInfo = {
        TaskId: row.TaskId,
        Operation: "top"
      };
      this.loading = true;
      this.loadingText = '更新中...';
      new MyApis.PlanTaskApi()
        .UpdateTaskOrderNo(searchInfo)
        .then(() => {
          this.loading = false;
          this.search();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //置底
    placebottomClick(index, row) {
      //console.log(index);
      let searchInfo = {
        TaskId: row.TaskId,
        Operation: "end"
      };
      this.loading = true;
      this.loadingText = '更新中...';
      new MyApis.PlanTaskApi()
        .UpdateTaskOrderNo(searchInfo)
        .then(() => {
          this.loading = false;
          this.search();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    ConvertExecWay(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      if (data == "1") {
        return "自动执行";
      }
      if (data == "2") {
        return "人工启动";
      }
    }
  }
  ,watch: {
    PlanId: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        console.log('task list watch');
        this.PlanId = val;
        this.search();
      },
      immediate: true,
      deep: true,
    },
  }
};
</script>